import { useEffect } from "react";

import { smoothCenterBlock } from "../util";

export const useScrollToActiveTextBlock = (
  scrollRef: HTMLElement,
  elRef: HTMLElement | null,
  shouldScroll: boolean,
) => {
  useEffect(() => {
    if (elRef && shouldScroll) {
      smoothCenterBlock(scrollRef, elRef.offsetTop, elRef.clientHeight);
    }
  }, [elRef, scrollRef, shouldScroll]);
};
